module.exports = __webpack_public_path__ + "img/shop-2_720x446.0da46494.jpg";